import { useDispatch } from 'react-redux';
import { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

import './styles.scss';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { setGuideBoardVisible } from 'store/actions';

import { ArrowUp } from 'components/icons';
import { ROUTE_MAP } from 'consts/url';

const keyArr = Object.keys(ROUTE_MAP).map((key) => ROUTE_MAP[key].id);

const MenuTop = () => {
  const [openMenuMobile, setOpenMenuMobile] = useState(false);
  // const { scenes } = useSelector((state) => state);
  const history = useHistory();
  const dispatch = useDispatch();

  const { pathname } = useLocation();

  const newPathName = pathname.split('/')[1] || '';

  // const [initialScene, mainScene] = useMemo(() => {
  //   return [
  //     sceneDataUtils.findIndoorInitialScene(scenes),
  //     sceneDataUtils.findMainScene(scenes),
  //   ];
  // }, [scenes]);

  const menuOverwride = useMemo(
    () => [
      {
        id: ROUTE_MAP.overview.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.overview.id}`);

          dispatch(setGuideBoardVisible(true));
        },
        name: ROUTE_MAP.overview.label,
      },
      {
        id: ROUTE_MAP.neighborhood.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.neighborhood.id}`);
        },
        name: ROUTE_MAP.neighborhood.label,
      },

      {
        id: ROUTE_MAP.masterplan.id,
        onClick: () => {
          history.push(`/${ROUTE_MAP.masterplan.id}`);
        },
        name: ROUTE_MAP.masterplan.label,
      },
      {
        id: ROUTE_MAP['floor-plan'].id,
        onClick: () => {
          history.push(`/${ROUTE_MAP['floor-plan'].id}`);
        },
        name: ROUTE_MAP['floor-plan'].label,
      },
      {
        id: ROUTE_MAP.interior.id,
        onClick: () => {
          // dispatch(
          //   updateWorldParams({
          //     groupId: initialScene.groupId,
          //     sceneId: initialScene.id,
          //   })
          // );
          dispatch(setGuideBoardVisible(true));
          history.push(`/${ROUTE_MAP.interior.id}/1br/overview`);
        },
        name: ROUTE_MAP.interior.label,
      },
    ],
    [dispatch, history]
  );

  const mapMenuToPath = useMemo(() => {
    return menuOverwride;
  }, [menuOverwride]);

  return (
    <>
      <div
        className={`nav-desktop-container ${
          openMenuMobile ? 'open-mobile' : ''
        }`}
      >
        <div className="menu-logo">
          <div className="logo-container">
            <img src={'/assets/wincity-logo.png'} alt="Logo" />
          </div>
          <button
            className="menu-arrow"
            onClick={() => setOpenMenuMobile((prev) => !prev)}
          >
            <ArrowUp />
          </button>
        </div>
        <div className="menu-content">
          {mapMenuToPath.map((item) => {
            let isActive = false;

            if (keyArr.includes(newPathName)) {
              isActive = newPathName === item.id;
            } else {
              isActive = item.id === 'overview';
            }

            return (
              <button
                key={item.id}
                onClick={item.onClick}
                className={`menu-item ${isActive ? 'active' : ''}`}
              >
                <span className="menu-item-label">{item.name}</span>
              </button>
            );
          })}
        </div>
      </div>

      {/* <div className="nav-mobile-container">
        <div className="menu-logo">
          <img
            src={'/assets/images/logo/wincity-logo-mobile.webp'}
            alt="Logo"
          />
        </div>
        <button
          className="menu-trigger"
          onClick={() => setOpenMenuMobile(!openMenuMobile)}
        >
          <span className="btn-label">{openMenuMobile ? 'CLOSE' : 'MENU'}</span>
          <IconHamburger isActive={openMenuMobile} />
        </button>

        <div className={`nav-mobile-menu ${openMenuMobile ? 'open' : ''}`}>
          {mapMenuToPath.map((item) => {
            let isActive = false;

            if (keyArr.includes(newPathName)) {
              isActive = newPathName === item.id;
            } else {
              isActive = item.id === 'overview';
            }

            return (
              <button
                key={item.id}
                onClick={() => {
                  item.onClick();
                  setOpenMenuMobile(false);
                }}
                className={`menu-item ${isActive ? 'active' : ''}`}
              >
                {item.name}
              </button>
            );
          })}
        </div>
      </div> */}
    </>
  );
};

export default MenuTop;
